"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFormField = exports.createFormToCreateModal = exports.BASE_CLASS_NAME = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FormToCreateStore_1 = __importDefault(require("Common/FormToCreate/FormToCreateStore"));
var Environment_1 = require("@CommonFrontendBackend/Environment");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
exports.BASE_CLASS_NAME = "form-to-create";
var FormToCreate = (function (_super) {
    __extends(FormToCreate, _super);
    function FormToCreate(props) {
        return _super.call(this, props) || this;
    }
    FormToCreate.prototype.render = function () {
        var _a = this.props, title = _a.title, explainer = _a.explainer, dataStore = _a.dataStore, isNonProductionEnvironment = _a.isNonProductionEnvironment, fields = _a.fields;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME) },
                react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__header center") },
                    react_1.default.createElement("header", { className: "header" },
                        react_1.default.createElement("h3", { className: "title" }, title),
                        react_1.default.createElement("p", { className: "explainer" }, explainer))),
                react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__body") },
                    react_1.default.createElement(kaleidoscope_1.Form, { width: kaleidoscope_1.FormWidth.Wide, dataStore: dataStore, fields: fields, onComplete: function () { return Promise.resolve(); }, allowDevAutocomplete: isNonProductionEnvironment, hideSubmitButton: true, inputSize: kaleidoscope_1.FormInputSize.Medium })))));
    };
    FormToCreate = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], FormToCreate);
    return FormToCreate;
}(react_1.default.Component));
exports.default = FormToCreate;
var createFormToCreateModal = function (modal, environment, tokens, telemetry, createProject, formConfig) {
    if (formConfig === void 0) { formConfig = {}; }
    return __awaiter(void 0, void 0, Promise, function () {
        var fields, formToCreateStore, token_counts, eventName, handleCloseAnalytics;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fields = tokens.map(function (t) { return (0, exports.createFormField)(t.name, t.apiName); });
                    formToCreateStore = new FormToCreateStore_1.default();
                    token_counts = countTokensByProvider(tokens);
                    eventName = "Template Gallery - Create form displayed";
                    telemetry.trackOnly(eventName, token_counts, { blockIntercom: true });
                    handleCloseAnalytics = function (submitted) {
                        var eventName;
                        var parameters;
                        if (submitted) {
                            eventName = "Template Gallery - Create form submitted";
                            parameters = {
                                completed_form_fields: formToCreateStore.count(),
                                empty_form_fields: tokens.length - formToCreateStore.count(),
                            };
                        }
                        else {
                            eventName = "Template Gallery - Create form cancelled";
                            parameters = {};
                        }
                        telemetry.trackOnly(eventName, parameters, { blockIntercom: true });
                    };
                    return [4, modal
                            .showConfirmModal({
                            header: (react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "-wrapper") },
                                react_1.default.createElement(FormToCreate, { title: "Create a page with tokens", explainer: "Fill in the tokens below to personalise your Qwilr Page. If you leave a token blank, you can always add that information to the page later. ".concat(formConfig.explainer || ""), dataStore: formToCreateStore, isNonProductionEnvironment: (0, Environment_1.isNonProductionEnvironment)(environment), fields: fields }))),
                            confirmLabel: "Create Page",
                            confirming: function () { return __awaiter(void 0, void 0, void 0, function () {
                                var substitutions, tokens_1, tokens_1_1, token;
                                var e_1, _a;
                                var _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            substitutions = {};
                                            try {
                                                for (tokens_1 = __values(tokens), tokens_1_1 = tokens_1.next(); !tokens_1_1.done; tokens_1_1 = tokens_1.next()) {
                                                    token = tokens_1_1.value;
                                                    substitutions[token.apiName] = (_b = formToCreateStore.getById(token.apiName)) !== null && _b !== void 0 ? _b : "";
                                                }
                                            }
                                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                            finally {
                                                try {
                                                    if (tokens_1_1 && !tokens_1_1.done && (_a = tokens_1.return)) _a.call(tokens_1);
                                                }
                                                finally { if (e_1) throw e_1.error; }
                                            }
                                            return [4, createProject(substitutions)];
                                        case 1:
                                            _c.sent();
                                            return [2];
                                    }
                                });
                            }); },
                            isEscapable: false,
                        })
                            .then(handleCloseAnalytics)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    });
};
exports.createFormToCreateModal = createFormToCreateModal;
var createFormField = function (tokenName, tokenApiName) {
    return {
        id: tokenApiName,
        type: kaleidoscope_2.FormType.Text,
        props: {
            label: tokenName,
            placeholder: "Type something",
        },
        maxTextInputLength: Types_1.MAX_TOKEN_SUBSTITUTION_VALUE_LENGTH,
        validate: function (value) { },
    };
};
exports.createFormField = createFormField;
var countTokensByProvider = function (tokens) {
    return tokens.reduce(function (accumulator, currentToken) {
        if (accumulator[currentToken.providerType]) {
            accumulator["".concat(currentToken.providerType, "_fields")] = accumulator[currentToken.providerType] + 1;
        }
        else {
            accumulator["".concat(currentToken.providerType, "_fields")] = 1;
        }
        return accumulator;
    }, {});
};
